module.exports = __webpack_public_path__ + "img/filledBookmark.1304e2d0.svg";